export const TOGGLE_SIDEBAR = "toggle_sidebar";
export const toggleSidebar = (value) => {
  return {
    type: TOGGLE_SIDEBAR,
    value: value
  };
};


